import { colorsPalettes } from "@similarweb/styles";
import { CHART_COLORS } from "app/constants/ChartColors";

const { blue, carbon } = colorsPalettes;

export const COMMON_COLORS = {
    BLUE: blue[400],
    LIGHT_BLUE: blue[300],
    OTHER: carbon[100],
    OTHER_CHART: carbon[50],
    ORANGE: CHART_COLORS.periodOverPeriod.Total[1],
};
